import React from 'react';
import LazyLoad from 'react-lazyload';

const LazyLoadImg = (props) => {
    return (
        <LazyLoad height={200}>
            <img src={props.image} mode='aspectFit' alt={props.alt || 'lazyload img'} className={ props.className } />
        </LazyLoad>
    )
}

export default LazyLoadImg;